// extracted by mini-css-extract-plugin
module.exports = {"container":"DashboardPage_container__3YCG0","title":"DashboardPage_title__3kvQs","section":"DashboardPage_section__9FG7I","sectionLoading":"DashboardPage_sectionLoading__2zeRm"};